import React from 'react'

function ProfileFlightPassed() {
  return (
    <div>ProfileFlightPassed</div>
  )
}

export default ProfileFlightPassed